<template>
  <div class="share-content">
    <el-card class="card">
      <div class="header">
        <h3>
          Compartilhar
        </h3>
        <el-button type="text" @click="close">
          Fechar
        </el-button>
      </div>

      <div class="body">
        <div ref="leftRef" class="left">
          <div class="bold">
            {{ prestador.nome_prestador }}
          </div>
          <div>
            {{ prestador.especialidade }}
          </div>
          <div>
            {{ prestador.telefone_primario }}
          </div>
          <div class="small">
            <span>
              {{ prestador.endereco }}
            </span>
            <span>
              {{ prestador.numero }}
            </span>
            <span>
              {{ prestador.complemento }}
            </span>
            <span>
              {{ prestador.bairro }}
            </span>
            <span>
              {{ prestador.nome_cidade }}
            </span>
            <span>
              {{ prestador.nome_estado }}
            </span>
            <span>
              {{ prestador.cep }}
            </span>
          </div>
          <div>
            {{ urlMapa }}
          </div>
        </div>
        <div class="right">

          <el-popover placement="bottom" title="Copiado" :width="225" trigger="click" :hide-after="150"
                      content="As informações foram copiadas."
          >
            <template #reference>
              <el-button type="text" @click="copy()">
                <span>
                  Copiar
                </span>
                <i class="el-icon-copy-document" />
              </el-button>
            </template>
          </el-popover>

        </div>
      </div>

      <div class="commands">
        <div class="command">
          <div class="icon whats" @click="shareWithWhatsapp">
            <SvgIcone icone="Dash_whatsapp" :height="15" :cor="'#FFFFFF'" />
          </div>
          <div>
            WHATSAPP
          </div>
        </div>
        <div class="command">
          <div class="icon mail" @click="shareWithMail">
            <SvgIcone icone="icon_mini_email" :height="15" :cor="'#FFFFFF'" />
          </div>
          <div>
            E-MAIL
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'Func4Share',
  computed: {
    ...mapGetters('RedeCredenciada', ['prestador']),
    urlMapa () {
      const lat = this.prestador.latitude.replace(',', '.')
      const lng = this.prestador.longitude.replace(',', '.')
      return `https://google.com/maps/?q=${lat},${lng}`
    }
  },
  props: {
    onCloseClick: {}
  },
  methods: {
    close () {
      this.$emit('onCloseClick')
    },
    copy () {
      const textToCopy = this.$refs.leftRef.innerText
      this.$clipboard(textToCopy)
    },
    shareWithMail () {
      const text = this.$refs.leftRef.innerText
      const textEncoded = encodeURI(text)
      const name = this.prestador.nome_prestador
      const nameEncoded = encodeURI(name)
      const link = `mailto:?to=&body=${textEncoded},&subject=${nameEncoded}`
      window.open(link)
    },
    shareWithWhatsapp () {
      const text = this.$refs.leftRef.innerText
      const textEncoded = encodeURI(text)
      const link = `https://api.whatsapp.com/send/?phone&text=${textEncoded}&app_absent=0`
      window.open(link)
    }
  }
}
</script>

<style scoped lang="less">

.share-content {
  position: absolute;
  display: flex;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #ffffffa8;
  z-index: 100000;
  place-content: center;
  place-items: center;

  .card {
    width: 500px;
    max-width: 90%;

    .header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid lightgrey;
      padding-bottom: 16px;
      margin-bottom: 16px;
    }

    .body {
      border: 1px solid lightgrey;
      margin: 8px 0;
      border-radius: 5px;
      background: #f5f5f5;
      display: flex;
      overflow: hidden;

      .left {
        padding: 16px;
        border-right: 1px solid lightgrey;
        width: 100%;
      }

      .right {
        display: flex;
        background: white;
        place-items: center;
      }
    }

    .commands {
      display: flex;
      place-content: center;
      gap: 32px;
      margin-top: 16px;

      .command {
        color: var(--cor-primaria-aplicacao);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        font-size: smaller;
        font-weight: bold;
        place-items: center;
        text-align: center;
        width: 72px;

        .icon {
          width: 64px;
          height: 64px;
          border-radius: 100%;
          margin-bottom: 8px;
          cursor: pointer;

          &.whats {
            background-color: #25d366;
          }

          &.mail {
            background-color: #bdbdbd;
          }

          svg {
            width: 60%;
            height: 100%;
          }
        }
      }
    }
  }
}

.bold {
  font-weight: bold;
}

.small {
  font-size: small;
}

</style>
